//
//
//
//
//
//
//
//
//
//
//
//

import Stars from '@/common/tpl/value_analysis/_stars'
export default {
    props: {
        msg: Object
    },
    components: {
        Stars
    },
    computed: {
        tip() {
            return this.msg.classname === 'self' ? '已向对方发送楼盘报告' : '免费解锁'
        },
        formatScore() {
            return (value) => {
                let score = parseInt(value)
                if (score >= 5 && score < 7) {
                    return 4
                } else if (score >= 7 && score < 8) {
                    return 4.5
                } else if (score >= 8) {
                    return 5
                }
                return 3
            }
        }
    },
    mounted() {
    },
    methods: {
        goMore() {
            wx.navigateTo({
                url: `/building/value_analysis/main?building_id=${this.msg.building_id}`
            })
        }
    }
}
